import type { User } from 'firebase/auth'
import type { ClaimInviteResult } from '../services/inviteService'
import { consumePendingLinkToken } from '../services/inviteService'

export const isExplicitInviteReviewRoute = (): boolean => {
  if (typeof window === 'undefined') return false
  return window.location.pathname.startsWith('/invite-review/') ||
    window.location.pathname.startsWith('/join/')
}

/**
 * Resolves any pending invites for a freshly-authenticated user. Runs both the
 * email/phone matcher AND the LINK-token handoff (set by the mobile shell or
 * /join landing). Failures are logged but never thrown — the resolver must
 * not block the user from reaching the app.
 */
export const resolvePendingLinkInvite = async (user?: Partial<User> | null): Promise<ClaimInviteResult[]> => {
  void user
  const claimed: ClaimInviteResult[] = []
  if (isExplicitInviteReviewRoute()) return claimed

  // Deep-link / mobile-shell handoff first — explicit user review on /invite-review/<token>.
  try {
    const token = consumePendingLinkToken()
    if (token) {
      const targetPath = `/invite-review/${token}`
      if (typeof window !== 'undefined' && window.location.pathname !== targetPath) {
        window.location.assign(targetPath)
      }
    }
  } catch (error) {
    console.warn('[resolvePendingLinkInvite] Link token review navigation failed.', error)
  }

  return claimed
}
